import { Directive, Attribute, forwardRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { Regex } from '../../core/constants/app.constant';

@Directive({
  selector: '[parValidateEqual][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EqualValidatorDirective),
      multi: true
    }
  ]
})
export class EqualValidatorDirective implements Validator {
  /***************Properties***************/
  private get isReverse() {
    return this.reverse === 'true' ? true : false;
  }
  @Input() pattern: string;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    @Attribute('parValidateEqual') public validateEqual: string,
    @Attribute('reverse') public reverse: string
  ) {}
  /***************Constructor***************/

  /***************Validator Implementation***************/
  validate(control: AbstractControl): { [key: string]: any } {
    const compareControl = control.parent.get(this.validateEqual);
    if (this.isValidControlValues(control, compareControl)) {
      if (
        compareControl &&
        control.value !== compareControl.value &&
        !this.isReverse
      ) {
        return {
          validateEqual: true
        };
      }

      if (
        compareControl &&
        control.value === compareControl.value &&
        this.isReverse
      ) {
        delete compareControl.errors['validateEqual'];
        if (!Object.keys(compareControl.errors).length) {
          compareControl.setErrors(null);
        }
      }

      if (
        compareControl &&
        control.value !== compareControl.value &&
        this.isReverse
      ) {
        compareControl.setErrors({ validateEqual: true });
      }
    } else if (compareControl && compareControl.errors) {
      delete compareControl.errors['validateEqual'];
    }

    return null;
  }
  /***************Validator Implementation***************/

  /***************Private Methods***************/

  private isValidControlValues(
    control: AbstractControl,
    compareControl: AbstractControl
  ): boolean {
    let valid = false;

    if (control.value && compareControl && compareControl.value) {
      valid = this.pattern
        ? control.value.match(this.pattern) &&
          compareControl.value.match(this.pattern)
        : true;
    }

    return valid;
  }

  /***************Private Methods***************/
}
